// В.2.i: Боевой биотехник (liv_boevoy_biotehnik, common, 1/2/4).
// [Аура]: в Ф3 двухфазно лечит союзного Героя на 1 ХП.
//
// Хил-Аура через registerLivLifeHealAura — срабатывает в обоих раундах
// хил-прохода (round 1 ДО авто-атак, round 2 ПОСЛЕ). Лечит ТОЛЬКО союзного
// Героя на +1 ХП. Себя и других союзных юнитов не лечит.
//
// Молчание Биотехника блокирует Ауру (это уже в каркасе runLivLifeHealAuras).

import { registerLivLifeHealAura } from './heal-auras.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { healUnit } from './heal.js';

export const CARD_ID = 'liv_boevoy_biotehnik';
const HEAL_AMOUNT = 1;

registerImplementedAbility(CARD_ID, 'passive');

registerLivLifeHealAura(CARD_ID, (state, biotehnik, _round) => {
  const ownerIdx = biotehnik.ownerId;
  if (ownerIdx == null) return;
  const owner = state.players?.[ownerIdx];
  if (!owner?.hero) return;
  if (owner.hero.hp <= 0) return;
  // Лечит только Героя (не юнитов, не себя).
  healUnit(state, owner.hero, HEAL_AMOUNT, biotehnik);
});
